/**
 * Correlation id (observability RFC): one id per app load, attached to every
 * sink (Sentry tag, PostHog super property) so signals can be pivoted across
 * tools. Distinct from the vendor-managed PostHog `$session_id`.
 */
const observabilitySessionId: string = crypto.randomUUID()

export const OBSERVABILITY_SESSION_ID_KEY = 'session_id'

export const getObservabilitySessionId = (): string => observabilitySessionId
